import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DynamicReport from "../DynamicReport";
import BenchmarkingByTitle from "../BenchmarkingByTitle";

const Dashboard = () => {
  return (
    // <div className="bg-themeCore">
    //   <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center shadow-md">
    //     <div className="title text-themeBlue font-medium text-3xl">
    //       Dashboard
    //     </div>
    //   </div>

    // </div>
    // <BenchmarkingByTitle />
    <DynamicReport />
  );
};

export default Dashboard;
